var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitincreaseprocess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.976 19.6625H15.9951L2.021 0.900391H24.976C30.1608 0.900391 34.3605 5.10015 34.3605 10.2849C34.3605 15.4628 30.1608 19.6625 24.976 19.6625Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.021 19.6602L13.3344 35.098H34.5452L22.8351 19.6602H2.021Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitincreaseprocess);
export default __webpack_public_path__ + "static/media/limitincreaseprocess.9e113075113925bb4c1c62e686cf5916.svg";
export { ForwardRef as ReactComponent };